<template>
  <div class="main_center lawEnforcementList">
    <div class="content">
        <div class="search-content">
            <div class="mainBtn">
                <el-button @click="routerAdd()" size="small" type="primary" v-if="hasBtnPermission('btn_extract_configurationItem_add')">新增</el-button>
            </div>
            <div class="searchBtn">
                <span class="label-form">配置编号：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.configCode"></el-input>
                <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
<!--                <el-button size="mini" type="text" @click="moreSearchItem = true" icon="el-icon-arrow-down">更多搜索</el-button>-->
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
            </div>
        </div>
      <template v-if="addDialog">
        <extractConfigurationItem-detail ref="extractConfigurationItem" @handleClose="handleClose"></extractConfigurationItem-detail>
      </template>

      <el-table :data="tableData"
                class="table-content"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                v-loading="dataListLoading"
                ref="multipleTable"
                :height="tableMaxHeight" stripe border>
        <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_extract_configurationItem_del')" align="center"></el-table-column>
        <el-table-column fixed label="序号" type="index"  width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
<!--        <el-table-column label="启用状态" align="center" width="100">-->
<!--          <template slot-scope="scope">-->
<!--                <span style="display: inline-block;position: relative">-->
<!--                    <el-switch-->
<!--                            v-model="scope.row.status"-->
<!--                            :width="50"-->
<!--                            @change="(val)=>updateStatus(val,scope.row)"-->
<!--                            active-color="#1890FF"-->
<!--                            inactive-color="rgba(0, 0, 0, 0.25)">-->
<!--                    </el-switch>-->
<!--                    <span class="switch-text" :class="scope.row.status?'switch-active':'switch-inactive'">{{scope.row.status?'开启':'关闭'}}</span>-->
<!--                </span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="配置编号" prop='configCode' header-align="center" align="center" width='150'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="检查适用部门" prop='usableDeptCodeName' header-align="center" align="left" min-width='90'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="执法检查类型" prop='checkTypeName' align="center" width='150'
                         :show-overflow-tooltip='true'>
        </el-table-column>
          <el-table-column label="更新人" prop='updateUser' header-align="center" align="left" width='150'
                           :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column label="更新日期" prop='updateTime' header-align="center" align="center" width='120'
                           :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column label="创建时间" prop='createTime' header-align="center" align="center" width='120'
                           :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column label="状态"
                           prop='useStatus'
                           align="center" width='100'>
              <template slot-scope="scope">
                  <span>{{scope.row.useStatusName}}</span>
              </template>
          </el-table-column>
          <el-table-column label="有效期" prop='status' header-align="center" align="center" min-width='100'
                           :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                  <span>{{formatDate(scope.row.startTime,'yyyy-MM-dd') }} - {{formatDate(scope.row.endTime,'yyyy-MM-dd')}}</span>
              </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="180">
              <template slot-scope="scope">
                  <el-button type="text" size="small"  v-if="hasBtnPermission('btn_extract_configurationItem_add')" @click="router(scope.row)">修改</el-button>
                  <el-button type="text" size="small"  v-if="hasBtnPermission('btn_extract_configurationItem_add')" @click="router(scope.row,true)">复制修改</el-button>
                  <el-button type="text" size="small" title="删除" v-if="hasBtnPermission('btn_extract_configurationItem_del')" @click="deleteById(scope.row)">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      <paginationCom  @sizechange="sizeChangeHandle" @pagechange="pageChangeHandle" class="limit" :options="paginationOpt"></paginationCom>
    </div>
  </div>
</template>

<script>
    import { mapState } from "vuex";
    import extractConfigurationItem_detail from './extractConfigurationItem_detail.vue'
    import {syscheckitemconfigList,syscheckitemconfigDelete,updateStatusById} from '@/server/extractConfigurationItem'
    export default {
    components:{
      'extractConfigurationItem-detail':extractConfigurationItem_detail
    },
    data(){
      return {
        tableMaxHeight: document.documentElement.clientHeight - 237 ,
        dataListLoading: false,
        form: {
            configCode:"",
            tradeId:''
        },
        moreSearchItem: false,
        paginationOpt:{
          pageIndex:1,
          pageSize:10,
          total:0,
          pageSizes:[10,20,50]
        },
        tableData: [],
        addDialog:false,
      }
    },
    activated(){
      this.getData();
    },

    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if(resizeTag) { //防抖动
                that.ifmove();
                    resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    methods:{

        updateStatus(val,data){
            updateStatusById({id:data.id,status:val}).then(res => {
                if (res.data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    })
                    this.getData();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            })

        },

        ifmove() {
             // let hasBtnPermisson = this.hasBtnPermission('btn_extract_configurationItem_add');
             let tableMaxHeight = document.documentElement.clientHeight - 237;
             this.paginationOpt.pageSize= parseInt((tableMaxHeight) / 50 ) || 1;
             this.$nextTick(() => {
                 this.tableMaxHeight = tableMaxHeight
             })
           
        },
        getData() { // 获取列表数据
          this.dataListLoading=true;
          syscheckitemconfigList({
            'page': this.paginationOpt.pageIndex,
            'rows': this.paginationOpt.pageSize,
            'filter': this.form
          }).then(res => {
            this.tableData = res.data.rows;
            this.paginationOpt.total = res.data.total;
            this.$refs.multipleTable.doLayout();
          }).finally(()=>{this.dataListLoading = false})
        },
        // 每页长度改变
        sizeChangeHandle(value){
          this.paginationOpt.pageSize=value;
          this.paginationOpt.pageIndex=1;
          this.getData();
        },
        // 当前页改变
        pageChangeHandle(value){
          this.paginationOpt.pageIndex = value;
          this.getData();
        },
        indexMethod(index) {
            return (this.paginationOpt.pageSize - 1) * Number(this.paginationOpt.pageSize) + Number(index) + 1
        },
        //搜索按钮
        searchBtn(){
            this.paginationOpt.pageIndex = 1;
            this.getData();
        },
        refresh() {//刷新按钮
          this.paginationOpt.pageIndex = 1;
          Object.assign(this.$data.form, this.$options.data().form)
          this.getData();
        },
        routerAdd(id,copyFlag){//新增页面
          // this.title="新增配置项"
          // this.addDialog=true;
          // this.$nextTick(res=>{
          //   this.$refs.extractConfigurationItem.dialogVisible=true;
          // });
            removeTabHandle("extractConfigurationItem_detail")
          this.$router.push({
            name:'extractConfigurationItem_detail',
              query:{
                id:id || ''
              },
              params:{
                  copyFlag:copyFlag?true:false
              }
          })
        },
        handleClose(){//关闭弹框
          this.addDialog=false;
          this.getData();
        },
        router(item,copyFlag){ // 跳转详情
          var id = item? item.id:0;
          this.routerAdd(id,copyFlag);
          // this.$nextTick(res=>{
          //   this.$refs.extractConfigurationItem.getSingle(id);
          // });
          
        },
        deleteById(item) {
          this.$confirm(`确定要删除该数据?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            syscheckitemconfigDelete({id:item.id}).then(res => {
              if (res.data.code == '1') {
                this.$message({
                  type: 'success',
                  message: res.data.msg
                })
                this.getData();
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            })
          })
        },
    },

    destroyed(){
      window.onresize = null;
    },




}
</script>
<style lang="scss" scoped>

    //列表页面
    .main_center{
      .switch-text{
        font-size: 12px;
        position: absolute;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
      }
      .switch-active{
          left:7px;
      }
      .switch-inactive{
          right:7px;
      }
      .search-content{
        .searchBtn{
          display: flex;   
          align-items: center;   
        }
      }

    }

</style>
